import {menuItems} from 'config/menus'

export default async function getMenuData() {
  return menuItems
  /* let params = {}
  if(window.location.hostname === "app2.performahrm.com" ){
    params = {
      type: "stage",
      base_url: process.env.REACT_APP_PER1_URL
    }
  }
  return apiClient.get(`${process.env.REACT_APP_PER1_URL}/api/menus`,{params}).then(result => result.data).catch(() => menuItems)

   */
}
